import { z } from 'zod';

export const FeatureFlagsSchema = z.object({
  providerCalendar: z.boolean(),
  providerAvailabilitySearch: z.boolean(),
  // The API deploys ahead of the client; a payload without this key reads as closed.
  b2bOfferingListings: z.boolean().default(false),
});

export type FeatureFlags = z.infer<typeof FeatureFlagsSchema>;
export type FeatureFlagKey = keyof FeatureFlags;
